import Vue from 'vue'
import stream from 'stream'

class LogStream extends stream.Readable {
  constructor (jobId, execId, type) {
    super()
    this.jobId = jobId
    this.job_type = type
    this.execId = execId
    this.ended = false
    const request = {
      method: 'logs_subscribe',
      data: {
        job_id: jobId,
        execution_id: execId,
        job_type: type
      }
    }
    // Single source of truth for the channel so subscribe/unsubscribe can never drift apart.
    const execSuffix = this.execId ? `.${this.execId}` : ''
    this.channel = `ml.logs.${this.job_type}.${this.jobId}${execSuffix}`
    this.onMessage = this.onMessage.bind(this)
    Vue.WebSockets.subscribe(this.channel, this.onMessage)
    Vue.WebSockets.send('ML', request)
  }

  onMessage ({ data }) {
    if (!this.ended) {
      data.log.split('\n').forEach(line => {
        this.push(Buffer.from(line, 'utf-8'))
      })
    }
  }

  /* istanbul ignore next */
  _read () {
  }

  close () {
    const request = {
      method: 'logs_unsubscribe',
      data: {
        job_id: this.jobId,
        execution_id: this.execId,
        job_type: this.job_type
      }
    }
    Vue.WebSockets.send('ML', request)
    Vue.WebSockets.unsubscribe(this.channel, this.onMessage)
    this.ended = true
  }
}

export default LogStream
